import { LAYOUT_COLUMN__right } from '@/pages/_base/layout_base/LAYOUT_COLUMN__right';
import { G_BUTTON__generation_view_master } from './_buttons/button_generation/G_BUTTON__generation_view_master';
import { G_SWITCH__generation_graph_autorun_nodes } from './_buttons/G_SWITCH__generation_graph_autorun_nodes';

interface PROPS {}

export function G_HEADER__generation_actions({}: PROPS) {
  return (
    <LAYOUT_COLUMN__right>
      <div className="flex flex-center size-full shrink-0 select-none">
        {/* Show UI Button */}
        <G_SWITCH__generation_graph_autorun_nodes />
        <G_BUTTON__generation_view_master />
      </div>
    </LAYOUT_COLUMN__right>
  );
}
